module.exports = __webpack_public_path__ + "img/add-other-table-icon.f874cab3.svg";